import React from 'react';
import Radium from 'radium';
import Theme from '../../styles/theme';
import StyleDecorator from '../StyleDecorator';

class Button extends React.Component {
	static propTypes = {
		type: React.PropTypes.string,
		style: React.PropTypes.object,
		onTouchTap: React.PropTypes.func,
		disabled: React.PropTypes.bool,
		children: React.PropTypes.node,
	};

	static defaultProps = {
		type: 'button',
		style: {},
		onTouchTap: () => {},
		disabled: false,
	};

	handleOnTouchTap = (e) => {
		if (!this.props.disabled) {
			this.props.onTouchTap(e);
		}
	};

	getStyle() {
		return {
			button: {
				outline: 'none',
				color: Theme.palette.primary2Color,
				width: '100%',
				border: 'none',
				padding: '16px',
				cursor: 'pointer',
				backgroundColor: Theme.palette.primary1Color,
				transition: 'box-shadow 0.3s, transform 0.3s',
				fontFamily: 'PxGroteskRegular',
				':hover': {
					boxShadow: '-10px 8px 0 #3c3c3c',
					transform: 'translate(5px, -4px)',
				},
			},
		};
	}

	render() {
		const style = this.getStyle();

		return (
			<button
				disabled={this.props.disabled}
				type={this.props.type}
				style={[style.button, this.props.style]}
				onTouchTap={this.handleOnTouchTap}
			>
				{this.props.children}
			</button>
		);
	}
}

export default StyleDecorator(Radium(Button));



// WEBPACK FOOTER //
// ./src/components/buttons/Button.js